import { render, staticRenderFns } from "./shuzi.vue?vue&type=template&id=12f68bdf&scoped=true&"
import script from "./shuzi.vue?vue&type=script&lang=js&"
export * from "./shuzi.vue?vue&type=script&lang=js&"
import style0 from "./shuzi.vue?vue&type=style&index=0&id=12f68bdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f68bdf",
  null
  
)

export default component.exports